/**
 * Depreciation defaults for the Move-Out "Is this deduction fair?" tool.
 *
 * Basis: ATO effective-life schedule (TR 2022/1, carried into the 2025
 * Determination), used as a COMMON ESTIMATE only. The ATO table is for
 * tax depreciation, not tenancy law. Tribunals are not bound by it but
 * reason similarly. These are editable defaults, not law.
 *
 * Always pair the calculator with the disclaimer text at the bottom of
 * this file. Do not reword the legal/disclaimer content.
 */
export const DEPRECIATION_ITEMS = [
  {
    key: "carpet",
    label: "Carpet",
    default_useful_life_years: 8,
    confidence: "high",
    verified: true,
    source: "https://www.ato.gov.au/law/view/document?DocID=TXR%2FTR20221%2FNAT%2FATO%2F00015",
    note: "ATO effective life is 8 years (shortened from 10). Some older tenancy decisions used 10. Default 8, user can adjust 8-10.",
  },
  {
    key: "dishwasher",
    label: "Dishwasher",
    default_useful_life_years: 8,
    confidence: "high",
    verified: true,
    source: "https://www.ato.gov.au/law/view/document?DocID=TXR%2FTR20221%2FNAT%2FATO%2F00015",
    note: "ATO effective life 8 years.",
  },
  {
    key: "oven",
    label: "Oven / stove",
    default_useful_life_years: 12,
    confidence: "medium",
    verified: true,
    source: "https://www.ato.gov.au/law/view/document?DocID=TXR%2FTR20221%2FNAT%2FATO%2F00015",
    note: "Commonly ~12 years under the ATO schedule. Confirm against the current ATO Determination.",
  },
  {
    key: "blinds",
    label: "Blinds (internal)",
    default_useful_life_years: 10,
    confidence: "medium",
    verified: true,
    source: "https://www.ato.gov.au/law/view/document?DocID=TXR%2FTR20221%2FNAT%2FATO%2F00015",
    note: "Internal blinds are commonly estimated around 10 years; varies by type (roller, holland, venetian). User-adjustable.",
  },
  {
    key: "ceiling_fan",
    label: "Ceiling fan",
    default_useful_life_years: 5,
    confidence: "medium",
    verified: true,
    source: "https://www.ato.gov.au/law/view/document?DocID=TXR%2FTR20221%2FNAT%2FATO%2F00015",
    note: "Commonly estimated around 5 years (which is why fans under $300 are often immediately written off for tax). User-adjustable.",
  },
  {
    key: "paint",
    label: "Paint / repaint",
    default_useful_life_years: 7,
    confidence: "low",
    verified: false,
    source: "Convention only - no ATO effective life. Confirm with the state's Tenants' Union.",
    note: "IMPORTANT: paint is NOT an ATO depreciating asset (it's part of the building / a repair), so there is no official effective life. Tribunals commonly treat interior repaint on a useful-life convention often cited around 5-10 years. Treat this default as a rough convention only, clearly flag it as not an ATO figure and let the user adjust. Repainting to fix tenant damage may be charged differently from a routine repaint due for age.",
    notAtoFigure: true,
  },
  {
    key: "other",
    label: "Other (custom item)",
    default_useful_life_years: 10,
    confidence: "low",
    verified: false,
    source: null,
    note: "Pick a useful-life estimate that matches the kind of item.",
  },
];

/**
 * Disclaimer text. Used VERBATIM. Do not reword.
 */
export const DEPRECIATION_DISCLAIMER =
  "These useful-life figures are common estimates based on the ATO effective-life schedule, which is used for tax depreciation, not tenancy law. They are a guide, not a fixed rule. A tribunal weighs each case on its facts and is not bound by these numbers. Paint is not an ATO depreciating asset, so its figure is a rough convention only. This is general information, not legal advice. Confirm anything important with your state's Tenants' Union.";

/**
 * Liability waiver. Sits alongside the verbatim ATO disclaimer to make
 * absolutely clear that the calculator is a guide, not advice, and that
 * TenantTrail accepts no responsibility for any outcome of using it.
 * Mirrors the tone of /disclaimer and /terms.
 */
export const DEPRECIATION_LIABILITY =
  "Use at your own risk. TenantTrail provides this tool as a free guide only. We make no warranty as to the accuracy of any number it produces and accept no responsibility for any loss, decision or outcome resulting from its use. You should confirm anything important with your state's Tenants' Union before relying on it.";
